module.exports = __webpack_public_path__ + "img/mile2.9f35f6bf.jpg";